// AUTO-GENERATED crossword layout. Grid, numbering and clues for the
// one-year-anniversary puzzle. Every maximal run of two or more letters in the
// grid is a real entry, and the gold-circled cells read "I LOVE YOU" top to
// bottom, left to right.

export type CrosswordEntry = {
  number: number;
  dir: "across" | "down";
  row: number;
  col: number;
  answer: string;
  clue: string;
};

export const CROSSWORD_WIDTH = 25;
export const CROSSWORD_HEIGHT = 24;

/** "." marks a blank square. */
export const CROSSWORD_GRID: string[] = [
  ".P..........T......H.V...",
  ".I..P...CROZET.A...U.I...",
  ".L..A.A.O...A..U...MARGY.",
  ".A..PARTNER.M..G.BMA.G...",
  ".T..E.L.F..H...U...N.I...",
  ".EXERCISE.MORRISON...N..M",
  ".S....N.T..N...T..C..I..A",
  "......G.T..E.....PANCAKES",
  "TOBY..THIRTYONE...K.....T",
  "..O...O....M...PAPERWHITE",
  ".HUSBAND...O..O..O......R",
  "..Q......TWONINEFOURONE.C",
  ".SUNDAY.H..N..E..P......H",
  "..E..L..O........Y......E",
  "..T..W..M.PRECIOUSLOVE..F",
  "....DANCE........T..O....",
  "...K.Y...........I..WIFE.",
  "..FIRST...CLEANLINESS...M",
  "...S..O..........K.T....I",
  ".YES.PAUY.SLYFORTYFIVE..L",
  "......S......A.I...N..L.L",
  "..HEART......U.N...S..O.E",
  ".............D.G..FOREVER",
  ".............AISLE.N..E.."
];

export const CROSSWORD_ENTRIES: CrosswordEntry[] = [
  {
    "number": 6,
    "dir": "across",
    "row": 1,
    "col": 8,
    "answer": "CROZET",
    "clue": "The little Virginia town our vineyard calls home"
  },
  {
    "number": 9,
    "dir": "across",
    "row": 2,
    "col": 19,
    "answer": "MARGY",
    "clue": "Best wife in the world, by nickname"
  },
  {
    "number": 10,
    "dir": "across",
    "row": 3,
    "col": 4,
    "answer": "PARTNER",
    "clue": "In crime, in life, in everything"
  },
  {
    "number": 11,
    "dir": "across",
    "row": 3,
    "col": 17,
    "answer": "BMA",
    "clue": "The venue where we got married (initials)"
  },
  {
    "number": 13,
    "dir": "across",
    "row": 5,
    "col": 1,
    "answer": "EXERCISE",
    "clue": "What Paul started doing every single day this year"
  },
  {
    "number": 14,
    "dir": "across",
    "row": 5,
    "col": 10,
    "answer": "MORRISON",
    "clue": "James ___, who sings our song"
  },
  {
    "number": 17,
    "dir": "across",
    "row": 7,
    "col": 17,
    "answer": "PANCAKES",
    "clue": "Banana ___, made by Margot on a slow morning"
  },
  {
    "number": 18,
    "dir": "across",
    "row": 8,
    "col": 0,
    "answer": "TOBY",
    "clue": "Our teddy bear"
  },
  {
    "number": 20,
    "dir": "across",
    "row": 8,
    "col": 6,
    "answer": "THIRTYONE",
    "clue": "The date in August, spelled out"
  },
  {
    "number": 21,
    "dir": "across",
    "row": 9,
    "col": 15,
    "answer": "PAPERWHITE",
    "clue": "Paper is the traditional first-anniversary gift... and this year yours is a very particular kind of paper (come back to this last, Paul will help)"
  },
  {
    "number": 23,
    "dir": "across",
    "row": 10,
    "col": 1,
    "answer": "HUSBAND",
    "clue": "What Paul officially became on 31 August"
  },
  {
    "number": 25,
    "dir": "across",
    "row": 11,
    "col": 9,
    "answer": "TWONINEFOURONE",
    "clue": "Our favorite restaurant of the year, spelled right out (4 words)"
  },
  {
    "number": 26,
    "dir": "across",
    "row": 12,
    "col": 1,
    "answer": "SUNDAY",
    "clue": "The day of the week we got married"
  },
  {
    "number": 29,
    "dir": "across",
    "row": 14,
    "col": 10,
    "answer": "PRECIOUSLOVE",
    "clue": "Our song, by James Morrison (2 words)"
  },
  {
    "number": 31,
    "dir": "across",
    "row": 15,
    "col": 4,
    "answer": "DANCE",
    "clue": "What Sly45 made everybody do"
  },
  {
    "number": 33,
    "dir": "across",
    "row": 16,
    "col": 20,
    "answer": "WIFE",
    "clue": "What Margot officially became on 31 August"
  },
  {
    "number": 34,
    "dir": "across",
    "row": 17,
    "col": 2,
    "answer": "FIRST",
    "clue": "Which anniversary this one is"
  },
  {
    "number": 36,
    "dir": "across",
    "row": 17,
    "col": 10,
    "answer": "CLEANLINESS",
    "clue": "The one thing we (lovingly) bicker about most"
  },
  {
    "number": 39,
    "dir": "across",
    "row": 19,
    "col": 1,
    "answer": "YES",
    "clue": "What she said"
  },
  {
    "number": 40,
    "dir": "across",
    "row": 19,
    "col": 5,
    "answer": "PAUY",
    "clue": "Best husband in the world, by nickname"
  },
  {
    "number": 41,
    "dir": "across",
    "row": 19,
    "col": 10,
    "answer": "SLYFORTYFIVE",
    "clue": "The band that would not let anyone sit down at our wedding (spelled out)"
  },
  {
    "number": 45,
    "dir": "across",
    "row": 21,
    "col": 2,
    "answer": "HEART",
    "clue": "Where you have been kept all year"
  },
  {
    "number": 46,
    "dir": "across",
    "row": 22,
    "col": 18,
    "answer": "FOREVER",
    "clue": "How long will you love each other?"
  },
  {
    "number": 47,
    "dir": "across",
    "row": 23,
    "col": 13,
    "answer": "AISLE",
    "clue": "What Margot walked down"
  },
  {
    "number": 1,
    "dir": "down",
    "row": 0,
    "col": 1,
    "answer": "PILATES",
    "clue": "The workout Margot took up this year"
  },
  {
    "number": 2,
    "dir": "down",
    "row": 0,
    "col": 12,
    "answer": "TEAM",
    "clue": "What the two of us have always been"
  },
  {
    "number": 3,
    "dir": "down",
    "row": 0,
    "col": 19,
    "answer": "HUMAN",
    "clue": "What we call each other: my ___"
  },
  {
    "number": 4,
    "dir": "down",
    "row": 0,
    "col": 21,
    "answer": "VIRGINIA",
    "clue": "The state that holds our home, our honeymoon and our anniversary trip"
  },
  {
    "number": 5,
    "dir": "down",
    "row": 1,
    "col": 4,
    "answer": "PAPER",
    "clue": "The traditional gift for a first anniversary"
  },
  {
    "number": 6,
    "dir": "down",
    "row": 1,
    "col": 8,
    "answer": "CONFETTI",
    "clue": "Falling all over this very page"
  },
  {
    "number": 7,
    "dir": "down",
    "row": 1,
    "col": 15,
    "answer": "AUGUST",
    "clue": "The month we said \"I do\""
  },
  {
    "number": 8,
    "dir": "down",
    "row": 2,
    "col": 6,
    "answer": "ARLINGTON",
    "clue": "The town where our first home together still is"
  },
  {
    "number": 12,
    "dir": "down",
    "row": 4,
    "col": 11,
    "answer": "HONEYMOON",
    "clue": "The trip that started it all, one year ago"
  },
  {
    "number": 15,
    "dir": "down",
    "row": 5,
    "col": 24,
    "answer": "MASTERCHEF",
    "clue": "The show we have watched more of this year than any other"
  },
  {
    "number": 16,
    "dir": "down",
    "row": 6,
    "col": 18,
    "answer": "CAKE",
    "clue": "Cut together, hopefully not thrown"
  },
  {
    "number": 19,
    "dir": "down",
    "row": 8,
    "col": 2,
    "answer": "BOUQUET",
    "clue": "Thrown over the shoulder"
  },
  {
    "number": 22,
    "dir": "down",
    "row": 9,
    "col": 17,
    "answer": "POOPYSTINKY",
    "clue": "Our own two-word way of saying \"ah, crap\""
  },
  {
    "number": 24,
    "dir": "down",
    "row": 10,
    "col": 14,
    "answer": "ONE",
    "clue": "How many years, as of today"
  },
  {
    "number": 27,
    "dir": "down",
    "row": 12,
    "col": 5,
    "answer": "ALWAYS",
    "clue": "Not just for now, but ___"
  },
  {
    "number": 28,
    "dir": "down",
    "row": 12,
    "col": 8,
    "answer": "HOME",
    "clue": "Not a place so much as a person"
  },
  {
    "number": 30,
    "dir": "down",
    "row": 14,
    "col": 20,
    "answer": "VOWS",
    "clue": "The promises we made in front of everyone"
  },
  {
    "number": 32,
    "dir": "down",
    "row": 16,
    "col": 3,
    "answer": "KISS",
    "clue": "How the ceremony ended"
  },
  {
    "number": 35,
    "dir": "down",
    "row": 17,
    "col": 6,
    "answer": "TOAST",
    "clue": "Raised, with a glass, to us"
  },
  {
    "number": 37,
    "dir": "down",
    "row": 17,
    "col": 19,
    "answer": "STINSON",
    "clue": "The vineyard: honeymoon then, anniversary now"
  },
  {
    "number": 38,
    "dir": "down",
    "row": 17,
    "col": 24,
    "answer": "MILLER",
    "clue": "The last name we now share"
  },
  {
    "number": 42,
    "dir": "down",
    "row": 19,
    "col": 13,
    "answer": "FAUDA",
    "clue": "The show we got completely obsessed with and binged"
  },
  {
    "number": 43,
    "dir": "down",
    "row": 19,
    "col": 15,
    "answer": "RINGS",
    "clue": "What we slid onto each other's fingers"
  },
  {
    "number": 44,
    "dir": "down",
    "row": 20,
    "col": 22,
    "answer": "LOVE",
    "clue": "The whole point of all of it"
  }
];

/** Cells that spell the hidden message, in reading order. */
export const CROSSWORD_HIDDEN_CELLS: { row: number; col: number }[] = [{"row":1,"col":1},{"row":2,"col":1},{"row":5,"col":11},{"row":14,"col":20},{"row":15,"col":8},{"row":16,"col":5},{"row":18,"col":6},{"row":19,"col":7}];

export const CROSSWORD_HIDDEN_MESSAGE = "I LOVE YOU";
